import axios from 'axios'

export const cmdVals = {
    setTemp: 'setTemp',
    streamer: 'streamer',
    powerfull: 'powerfull',
    economy: 'economy',
    flow: 'flow',
    mode: 'mode',
    fanSpeed: 'fanSpeed',
    power: 'power',
}

export const objPropsFromCmdVals = {
    setTemp: 'set_temp',
    streamer: 'streamer',
    powerfull: 'powerfull',
    economy: 'economy',
    flow: 'flow',
    mode: 'mode',
    fanSpeed: 'fan_speed',
    power: 'power',
}
export const propsGetOnly = {
    curTemp: 'cur_temp',
    error: 'error',
    errorCode: 'error_code',
    connection: 'connection',
}

export const devApi = {
    mqttCtrl: {
        ctrl(mqttConn, device, cmdVal, dataToSend){
            if(typeof dataToSend === 'object'){
                dataToSend = JSON.stringify(dataToSend)
            }
            let topic = `/devices/conditioner/controls/${device.serial}/in/${cmdVal}`;
            mqttConn.publish(topic, dataToSend.toString())
        },

        subsToStates(mqttConn, device, onData){
            let topic = `/devices/conditioner/controls/${device.serial}/out/#`;
            mqttConn.subscribe(topic);
            mqttConn.addListener(
                `dev_${device.serial}_all_out`,
                `^/devices/conditioner/controls/${device.serial}/out/([^/]+)$`,
                (matches, msg) => {
                    onData(matches[1], msg.toString().toLowerCase())
                });
        },
    },

    http:{
        addFailStat(devId, onDone, onError){
            /*axios.post('/device/fail',{
                device_id: devId
            }).then((req)=>{
                if(onDone) onDone(req.data);
            }).catch((req)=>{
                if(onError) onError(req);
            })*/
        },
        ctrl(devId, cmd, val){
            axios.post(`/device/${devId}/ctrl`,{
                command: cmd,
                value: val,
            })
        }
    }
}
